<template>
    <v-container fluid>
        <v-row align="center" class="bgcPainel paddingMobile" style="padding: 60px 150px 0px 150px;"></v-row>
        <v-row class="paddingMobile" style="background-color: #efefef">
            <v-col cols="12" md="3">
                <v-card elevation="10">
                    <v-card-title style="font-family: sofia pro; color: #00294b;">Configurações</v-card-title>

                    <!-- ********************************************** -->



                    <v-list>
                        <v-list-group color="#ff770fe0" :value="true" prepend-icon="mdi-account-wrench">
                            <template v-slot:activator>
                                <v-list-item-title style="font-family: sofia pro;">Conta</v-list-item-title>
                            </template>

                            <router-link :to="{ path: item.path }" v-for="(item, i) in itemsConta" :key="i">
                                <v-list-item color="#ff770fe0">
                                    <v-list-item-icon class="pl-5">
                                        <v-icon small v-text="item.icon"></v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title style="font-family: sofia pro; font-size:10pt; " v-text="item.text">
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </router-link>
                        </v-list-group>
                    </v-list>

              

                    <!-- ********************************************** -->
                </v-card>
            </v-col>
            <v-col cols="12" md="9" class="pt-0 padCardMobile">
                <painelPerfil v-if="visualizacao === 'perfil'"></painelPerfil>
                <painelSeguranca v-if="visualizacao === 'seguranca'"></painelSeguranca>

                <painelImoveis v-if="visualizacao === 'imoveis'"></painelImoveis>
         
                <indicacao v-if="visualizacao === 'indicacao'"></indicacao>
                <painelProdutos v-if="visualizacao === 'produtos'"></painelProdutos>
                <painelServicos v-if="visualizacao === 'servicos'"></painelServicos>
                <painel-operadores v-if="visualizacao === 'operadores'"> </painel-operadores>
                <Transferencia v-if="visualizacao === 'transferencia'"></Transferencia>
                <interacoes v-if="visualizacao === 'interacoes'"></interacoes>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import painelPerfil from "../components/painelPerfil.vue";
import painelSeguranca from "../components/painelSeguranca.vue";

import painelImoveis from "../components/painelImoveis.vue";
import indicacao from "../components/indicacao.vue";
import painelProdutos from "../components/painelProdutos.vue";
import painelOperadores from "../components/painelOperadores.vue";
import painelServicos from "../components/painelServicos.vue";

import Transferencia from "../components/transferencia.vue";
import interacoes from "../components/interacoes.vue";

export default {
    name: "PainelUsuario",
    metaInfo: {
        title: "Painel - MarketPlace Ribus",
    },
    components: { painelServicos, painelPerfil, painelSeguranca, painelOperadores, painelImoveis, indicacao, painelProdutos, Transferencia, interacoes },
    data: () => ({
        rating: 2.3,
        visualizacao: 'perfil',
        selectedItem: 0,
        // items: [
        // ],
      
        itemsConta: [
            { text: 'Minhas informações', icon: 'mdi-cog', path: '/painel/perfil' },
           // { text: 'Operadores', icon: 'mdi-account-group', path: '/painel/operadores' },
        ],
        itemsChat: [
            { text: 'Conversas', icon: 'mdi-message-text', path: '/painel/interacoes' },
        ],
    }),
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        doLogout() {
            this.$store.dispatch("logout").then(() => {
                this.$router.replace("/")
                this.$root.$io.disconnect()
            })
        },
    },

    mounted() {
        window.scrollTo(0, 0);
        if (this.$route.params.strCategoria) {
            this.visualizacao = this.$route.params.strCategoria
        }
    },
    watch: {
        '$route.params.strCategoria': {
            handler: function (strCategoria) {
                if (strCategoria) {
                    this.visualizacao = strCategoria
                }
                else {
                    this.visualizacao = "perfil"
                }
            },
            deep: true,
            immediate: true
        }
    },
}
</script>

<style scope>
@media (min-device-width: 300px) and (max-device-width: 731px) {
    .paddingMobile {
        padding: 40px 0px !important;
    }

    .padCardMobile {
        padding: 40px 0px !important;
    }

    .offset-3 {
        margin-left: 0 !important;
    }
}

.notification {
    background-color: #ff8629;
    padding: 1px 6px;
    border-radius: 20px;
    color: #fff;
    font-size: 12px;

}


.StyleButton {
    background-color: #ff770fe0 !important;
    color: #fff;
    font-family: 'Poppins';
    border-radius: 50px;
    margin-top: 20px;
}

.spanLayout1 {
    margin-left: 65px;
    font-family: 'roboto';
    font-weight: 300;
    font-size: 12px;
    font-style: italic;
    text-align: right !important;
}

.bgcPainel {
    background-image: url("../assets/BANNER_RIBUS.webp");
    background-repeat: no-repeat;
    height: 250px;
    background-size: cover;
    background-attachment: fixed;
    background-color: rgba(255, 255, 255, 0.596);
    background-position: center;
}
</style>